import moment from 'moment';
import 'moment/locale/nb';

// Animation states for various animated components
export const animalRowVariants = {
  enter: {
    height: 'auto',
    overflow: 'visible',
    opacity: 1,
    transition: { duration: 0.35, ease: 'easeOut' },
  },
  exit: {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    transition: { duration: 0.9 },
  },
};

export const animalAddCommentVariants = {
  visible: {
    maxHeight: '400px',
    transition: { duration: 0.3 },
  },
  collapsed: {
    maxHeight: 0,
    overflow: 'hidden',
  },
};

export const errorMsgVariants = {
  visible: {
    maxHeight: '65px',
    transition: { duration: 0.3 },
  },
  collapsed: {
    maxHeight: 0,
    overflow: 'hidden',
  },
};

export const expandCollapseVariants = {
  visible: {
    height: 'auto',
    oveflow: 'visible',
    transition: { duration: 0.3 },
  },
  collapsed: {
    height: 0,
    overflow: 'hidden',
  },
};

export const padMarkNo = (str) => '00000000'.slice(str.toString().length) + str;

// isoweek / isoyear ensures weird cases like the last days in a year
// that actually are part of week 1 in the following year are handeled correctly


export const getCurrentWeek = () => moment().isoWeek();
export const getCurrentYear = () => moment().isoWeekYear();
export const getCurrentMoment = () => {
  const c = moment().date(window.date || moment().date()).month(window.month || moment().month()).hour(window.hour || moment().hour())
    .minute(window.minute || moment().minute());
  return c;
};

export const getActionName = (action) => {
  if (action === 'slaughter') {
    return 'registrere';
  } else if (action === 'buy') {
    return 'kjøpe';
  } else if (action === 'sell') {
    return 'selge';
  }
};
